var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("group-page-header", { attrs: { title: "Group Activity" } }),
      _vm._v(" "),
      _vm.canCreatePosts
        ? _c(
            "div",
            { staticClass: "form margin-10-top" },
            [
              _c("add-activity-panel", {
                attrs: {
                  holder: "Type here to update your Group",
                  "allow-add-to-diary": false,
                  "allow-add-to-other-users-diary": false,
                },
                on: { onSave: _vm.onSave },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("render-activity-feed", {
        attrs: { "activity-entry-point": _vm.activityEntryPoint },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }